import axios from "axios";
import { useLogin } from "@/composables/login/useLogin";

// 创建 axios 实例
const axiosInstance = axios.create();

// 添加响应拦截器
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const {
        action: { handleUnauthorized },
      } = useLogin();
      handleUnauthorized();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
